import { object, ObjectSchema, string } from 'yup';
import { IReferrerContact, IReferrerContactForSupportPeriodForm } from '../models';

export const referrerContactSchema = (): ObjectSchema<IReferrerContact | IReferrerContactForSupportPeriodForm> => {
    return object().shape({
        id: string().optional(),
        name: string().optional(),
        email: string().optional(),
        phone: string().optional(),
    });
};
